module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-container-single element-non-bodymatter element-type-toc",
    attrs: {
      "id": "table-of-contents"
    }
  }, [_c('div', {
    staticClass: "toc-heading"
  }, [_c('h3', {
    staticClass: "toc-title"
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('div', {
    staticClass: "toc-contents"
  }, [_c('div', {
    staticClass: "toc-bodymatter-group"
  }, [_c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    staticClass: "element-number"
  }, [_vm._v("1. ")]), _c('a', {
    attrs: {
      "href": "#/chapter001"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("A partridge in a pear tree")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    staticClass: "element-number"
  }, [_vm._v("2. ")]), _c('span', {
    attrs: {
      "href": "#/chapter002",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Two turtle doves")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    staticClass: "element-number"
  }, [_vm._v("3. ")]), _c('span', {
    attrs: {
      "href": "#/chapter003",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Three French hens")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    staticClass: "element-number"
  }, [_vm._v("4. ")]), _c('span', {
    attrs: {
      "href": "#/chapter004",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Four calling birds")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    staticClass: "element-number"
  }, [_vm._v("5. ")]), _c('span', {
    attrs: {
      "href": "#/chapter005",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Five golden rings")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    staticClass: "element-number"
  }, [_vm._v("6. ")]), _c('span', {
    attrs: {
      "href": "#/chapter006",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Six geese a-laying")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    staticClass: "element-number"
  }, [_vm._v("7. ")]), _c('span', {
    attrs: {
      "href": "#/chapter007",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Seven swans a-swimming")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    staticClass: "element-number"
  }, [_vm._v("8. ")]), _c('span', {
    attrs: {
      "href": "#/chapter008",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Eight maids a-milking")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    staticClass: "element-number"
  }, [_vm._v("9. ")]), _c('span', {
    attrs: {
      "href": "#/chapter009",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Nine ladies dancing")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    staticClass: "element-number"
  }, [_vm._v("10. ")]), _c('span', {
    attrs: {
      "href": "#/chapter010",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Ten lords a-leaping")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    staticClass: "element-number"
  }, [_vm._v("11. ")]), _c('span', {
    attrs: {
      "href": "#/chapter011",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Eleven pipers piping")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    staticClass: "element-number"
  }, [_vm._v("12. ")]), _c('span', {
    attrs: {
      "href": "#/chapter012",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Twelve drummers drumming")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-epilogue has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    attrs: {
      "href": "#/epilogue",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Epilogue")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-backmatter-group"
  }, [_c('div', {
    staticClass: "toc-item toc-item-element-non-bodymatter toc-item-element-type-acknowledgments has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    attrs: {
      "href": "#/acknowledgements",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Acknowledgements")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-non-bodymatter toc-item-element-type-about-author has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    attrs: {
      "href": "#/anotefromthepublisher",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("A note from the publisher")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-non-bodymatter toc-item-element-type-about-author has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    attrs: {
      "href": "#/lovecrimethrillerandmysterybooks",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Love crime, thriller and mystery books?")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-non-bodymatter toc-item-element-type-also-by has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    attrs: {
      "href": "#/youwillalsoenjoy",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("You will also enjoy:")])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31f1d30c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 66
// module chunks = 0